import { DetailedHTMLProps, ImgHTMLAttributes } from "react";
import styles from "./Logo.module.scss";
import { CompanyIcon } from "@/frontend/shared/assets/icons";
import clsx from "clsx";
import { useTopLeftPixelColor } from "@/frontend/shared/lib/hooks/useTopLeftPixelColor";

type TLogoProps = {
  logo?: string | null;
  size?: "small" | "normal" | "px16" | "px20" | "px40";
} & DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;

export function Logo({ logo, size = "normal" }: TLogoProps) {
  if (!logo) {
    return (
      <div className={clsx(styles.placeholderContainer, styles[size])}>
        <div className={clsx(styles.placeholder, styles[size])} />
        <CompanyIcon className={styles.placeholderIcon} />
      </div>
    );
  }

  // const { imgRef, color } = useTopLeftPixelColor();

  return (
    <img
      src={logo}
      // ref={imgRef}
      alt="Logo"
      className={clsx(styles.logo, styles[size])}
      // style={{ backgroundColor: color }}
    />
  );
}
